import { render } from "./TalentRecommended.vue?vue&type=template&id=0ac58c1c"
import script from "./TalentRecommended.vue?vue&type=script&lang=js"
export * from "./TalentRecommended.vue?vue&type=script&lang=js"

import "./TalentRecommended.vue?vue&type=style&index=0&id=0ac58c1c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__